import makeStyles from "@mui/styles/makeStyles";

export const useStyles = makeStyles((theme) => ({
  list: {
    listStyle: "none",
    margin: 0,
    padding: 0,
  },
  item: {
    padding: "12px 0",
    borderBottom: `1px solid ${theme.palette.grey[200]}`,
    [theme.breakpoints.up("md")]: {
      padding: "16px 0",
    },
  },
}));
